import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchMoldReceiving, editMoldReleaseData } from './store/slice';
import { fetchCustomers } from '../../core/redux/customer/slice';
import { showToast } from '../../core/redux/toast/slice';
import { MoldService } from '../../service/api/mold-service';
import { actions as releaseActions } from './store/slice';
import MoldReleaseModals from './mold-release-modals';
import MoldReleaseContent from './mold-release-content';
import MoldReleaseTopHead from './mold-release-top-head';
import { parseMoldReleaseDeepLink } from './mold-release-deep-link';

const { resetFilters } = releaseActions;

const MoldReleaseView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const openedDeepLinkKeyRef = useRef(null);

  useEffect(() => {
    dispatch(fetchMoldReceiving({ initialMoldInfoId: 0 }));
    dispatch(fetchCustomers({}));
    return () => dispatch(resetFilters());
  }, []);

  useEffect(() => {
    const deepLink = parseMoldReleaseDeepLink(location.search);
    if (!deepLink) {
      openedDeepLinkKeyRef.current = null;
      return undefined;
    }

    const key = `${deepLink.toolId || ''}:${deepLink.moldInfoId || ''}`;
    if (openedDeepLinkKeyRef.current === key) {
      return undefined;
    }

    let cancelled = false;
    (async () => {
      let toolId = deepLink.toolId;
      let moldReceiving = { toolID: toolId, moldInfoID: deepLink.moldInfoId };
      if (deepLink.moldInfoId) {
        try {
          const response = await MoldService.getMoldById(deepLink.moldInfoId);
          if (response?.status === 200 && response.response) {
            const mold = response.response;
            toolId = toolId || mold.toolID || mold.ToolID || '';
            moldReceiving = {
              ...mold,
              toolID: toolId,
              moldInfoID: deepLink.moldInfoId,
            };
          }
        } catch {
          // Open with ids from the notification if mold lookup fails.
        }
      }

      if (cancelled) {
        return;
      }

      if (!toolId) {
        dispatch(
          showToast({
            message: 'Could not open the mold release record from this notification.',
            type: 'warning',
          }),
        );
        openedDeepLinkKeyRef.current = key;
        return;
      }

      dispatch(
        editMoldReleaseData({
          moldReceiving: { ...moldReceiving, toolID: toolId },
          currentStatus: 0,
        }),
      );
      openedDeepLinkKeyRef.current = key;
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, location.search]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Mold Release</h4>
              </div>
            </div>
            <MoldReleaseTopHead />
          </div>
          <MoldReleaseContent />
          <MoldReleaseModals />
        </div>
      </div>
    </div>
  );
};

export default MoldReleaseView;
